import { render } from "./payout-order-list.vue?vue&type=template&id=235654f0&ts=true"
import script from "./payout-order-list.ts?vue&type=script&lang=ts"
export * from "./payout-order-list.ts?vue&type=script&lang=ts"

import "./payout-order-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__